export const success = "success";
export const failure = "failure";
export const openHistoryModal = "openHistoryModal";
export const closeHistoryModal = "closeHistoryModal";